module.exports = __webpack_public_path__ + "img/Result_Mid_0608_01_2.13d83803.png";